// appVersionApi.js
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../redux/baseQuery';
import { getLatestAppVersion } from '../../../graphql';
import { LazyAppVersion } from '../../../types';

export const appVersionApi = createApi({
  reducerPath: 'appVersionApi',
  baseQuery: baseQuery,
  tagTypes: ['AppVersion'],
  endpoints: (builder) => ({
    getAppVersion: builder.query<LazyAppVersion, null>({
      query: () => ({ body: getLatestAppVersion, variables: {} }),
      keepUnusedDataFor: 0, // Do not cache indefinitely
      providesTags: ['AppVersion'],
    }),
  }),
});

export const { useGetAppVersionQuery } = appVersionApi;
